module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-left-2.f458f302.png";